module.exports = __webpack_public_path__ + "img/Shirley Lua.fe767e07.jpg";